(() => {
  const cartProductSliderSelector = 'slider-component[data-slider][data-upsell-products], slider-component[data-slider][data-bundle-products]';
  const cartUpsellProductHolderSelector = '[data-upsell-products][data-upsell-product-limit]';
  const productSelector = 'quick-add-product';
  const flickityStateClasses = ['flickity-enabled', 'is-draggable', 'is-initialized', 'is-loading', 'single-slide'];
  const observedSliders = new WeakSet();
  const refreshingSliders = new WeakSet();

  const getRawProducts = (slider) => {
    return Array.from(slider.children).filter((child) => child.matches(productSelector));
  };

  const getUpsellProductLimit = (holder) => {
    const limit = parseInt(holder.getAttribute('data-upsell-product-limit'), 10);
    return Number.isFinite(limit) && limit > 0 ? limit : null;
  };

  const limitCartUpsellProducts = (holder) => {
    const limit = getUpsellProductLimit(holder);
    if (!limit) return;

    getRawProducts(holder).forEach((product, index) => {
      if (index >= limit) {
        product.remove();
      }
    });
  };

  const limitCartUpsellProductHolders = () => {
    document.querySelectorAll(cartUpsellProductHolderSelector).forEach(limitCartUpsellProducts);
  };

  const clearStaleSliderState = (slider) => {
    slider.flkty = null;
    delete slider.flickityGUID;
    slider.removeAttribute('tabindex');
    slider.classList.remove(...flickityStateClasses);
  };

  const refreshCartProductSlider = (slider) => {
    if (!slider?.matches?.(cartProductSliderSelector) || refreshingSliders.has(slider)) return;

    limitCartUpsellProducts(slider);

    const products = getRawProducts(slider);
    if (!products.length) return;

    refreshingSliders.add(slider);

    products.forEach((product) => {
      product.setAttribute('data-slide', '');
    });

    clearStaleSliderState(slider);

    slider.slides = slider.querySelectorAll('[data-slide]');
    slider.thumbs = slider.querySelectorAll('[data-slider-thumb]');
    slider.section = slider.closest('[data-section-id]');

    slider.dispatchEvent(new CustomEvent('theme:slider:init', {bubbles: false}));
    slider.dispatchEvent(new CustomEvent('theme:slider:reposition', {bubbles: false}));

    requestAnimationFrame(() => {
      refreshingSliders.delete(slider);
    });
  };

  const sliderObserver = new MutationObserver((mutations) => {
    const sliders = new Set();

    mutations.forEach((mutation) => {
      if (mutation.target.matches?.(cartProductSliderSelector)) {
        sliders.add(mutation.target);
      }
    });

    sliders.forEach((slider) => {
      requestAnimationFrame(() => refreshCartProductSlider(slider));
    });
  });

  const observeCartProductSliders = () => {
    document.querySelectorAll(cartProductSliderSelector).forEach((slider) => {
      if (observedSliders.has(slider)) return;

      sliderObserver.observe(slider, {childList: true});
      observedSliders.add(slider);
    });
  };

  const refreshCartProductSliders = () => {
    limitCartUpsellProductHolders();
    observeCartProductSliders();

    document.querySelectorAll(cartProductSliderSelector).forEach((slider) => {
      requestAnimationFrame(() => refreshCartProductSlider(slider));
    });
  };

  const init = () => {
    limitCartUpsellProductHolders();
    observeCartProductSliders();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }

  document.addEventListener('theme:cart:change', refreshCartProductSliders);
  document.addEventListener('shopify:section:load', refreshCartProductSliders);
})();
